import router from "@/router";
import axios from "axios";
import { Toast, Dialog, closeToast } from "vant";
import { ref } from "vue";
import { localCache } from "@/utils/Cache";
import store from "@/store";
import { delCookie } from "@/utils/delCookie";
const state = ref(true);
axios.defaults.timeout = 600000;
axios.defaults.headers.get["Content-Type"] =
  "application/x-www-form-urlencoded";
// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    //获取请求url
    Toast.loading({
      message: "数据加载中...",
      forbidClick: true,
      duration: 0,
    });
    config.headers["Authorization"] = localCache.getCache("collegeMoibleToken");
    // 百度地图 如果url纯在ak字段，修改baseUrl
    if (config.url.indexOf("ak") > -1) {
      config.baseURL = "";
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
// 响应拦截器
axios.interceptors.response.use(
  (res) => {
    if (res.data && res.config?.responseType == "blob") {
      if (res.data.type === "application/json") {
        Toast.clear();
        const reader = new FileReader();
        reader.readAsText(res.data, "utf-8");
        reader.onload = function () {
          const _res = JSON.parse(reader.result);
          if (_res.code == 500) {
            Dialog.confirm({
              title: "错误提示",
              message: _res.msg,
              confirmButtonText: "关闭",
              showCancelButton: false,
            });
            return Promise.reject(_res.msg);
          }
          // 此处为接口返回值
        };
      }
      Toast.clear();
      return res;
    }
    if (res.data.code == 501) {
      if (state.value) {
        state.value = false;
        Dialog.confirm({
          title: "系统提示",
          message: "登陆已过期,请重新登录",
          confirmButtonText: "关闭",
          showCancelButton: false,
        }).then(() => {
          state.value = true;
          delCookie();
          window.open(store.state.menuList.ownUrl + "#/login", "_self");
          localCache.clearCache();
        });
      }
    } else if (res.data.code == 500 || res.data.code == 123) {
      Toast.clear();
      Dialog.confirm({
        title: "错误提示",
        message: res.data.msg,
        confirmButtonText: "关闭",
        showCancelButton: false,
      }).then(() => {});
      return Promise.reject(res.data.msg);
    } else if (res.data.code == 403 || res.data.code == 401) {
      Toast.clear();
      Dialog.confirm({
        title: "错误提示",
        message: res.data.msg,
        confirmButtonText: "关闭",
        showCancelButton: false,
      }).then(() => {
        sessionStorage.clear();
        router.push({ path: "/login" });
      });
    } else if (res.data.code == 201) {
      Toast.clear();
      return res.data;
    } else if (res.data.code == 101) {
      Toast.clear();
      router.push({ path: "/error" });
    }
    Toast.clear();
    return res.data;
  },
  (err) => {
    Toast.clear();
    return Promise.reject(err);
  }
);
export default axios;
